<template>

</template>

<script>
export default {
  name: "receivablesInvoiceSummary"
}
</script>

<style scoped>

</style>